<ae-cards *ngIf="fatura" [ngClass]="{'error': isOverDue(fatura.dueDate)}"
  navigate="/fatura-escolha-pagamento/{{fatura.bankSliptId}}"
  [ngStyle]="{'pointer-events': fatura.agendamentoStatus !=null && fatura.agendamentoStatus == 'AGENDADO' ? 'none': 'auto'}">
  <div class="descricao">{{fatura.description}}</div>
  <p class="titulovalor">
    <strong>{{fatura.title}}</strong><br />
    <img
      src="assets/img/icons/coin.svg">{{ formatCurrencyBrazil(fatura.value.toString()) + (fatura.agendamentoStatus != null && fatura.agendamentoStatus == 'AGENDADO' ? " - Cobrança agendada via cartão *" : "")}}
  </p>
  <div class="vencimento">
    <span *ngIf="!isOverDue(fatura.dueDate)">Pague até o dia </span>
    <span *ngIf="isOverDue(fatura.dueDate)">Venceu em </span>
    {{dateStringToBrazil(fatura.dueDate)}}
  </div>
</ae-cards>
<div *ngIf="!fatura">
  <h3>Fatura não encontrada</h3>
  <hr>
</div>
